import React from 'react';
import { useParams } from 'react-router-dom';
import useDeviceDetect from '../../../../hooks/useDeviceDetect';
import DefaultBoard from './index';
import MobileDynamicBoard from '../../../../components/Board/DynamicBoard/MobileDynamicBoard';

const ResponsiveDynamicBoard = () => {
  const { Id } = useParams();
  const { isMobile } = useDeviceDetect();

  return (
    <>
      {isMobile ? (
        <MobileDynamicBoard {...{ tableName: Id }} />
      ) : (
        <DefaultBoard {...{ tableName: Id }} />
      )}
    </>
  );
};

export default ResponsiveDynamicBoard;